import {ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';
import {EQrCodeKind} from '@shared/enums/qr-code.kind';
import {ERouteParam} from '@shared/enums/route-param';

export const canActivateQrKindGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const kind = route.paramMap.get(ERouteParam.qrCodeId);

  return kind && kind.toUpperCase() in EQrCodeKind;
};
